export default {
  legacy: false,
  locale: 'es-ES',
  fallbackLocale: 'es-ES',
  fallbackWarn: true,
}